module.exports = __webpack_public_path__ + "img/common.f6c1283d.svg";